import { Stack } from "@similarweb/ui-components/foundations";

import { AlertsErrorBoundary } from "../AlertsErrorBoundary";
import { SeoAlertsFeed, SeoAlertsFilters } from "../seo-alerts";

export const SeoPanel = () => {
    return (
        <Stack
            gap="32px"
            flexGrow={1}
        >
            <SeoAlertsFilters />
            <AlertsErrorBoundary alertType="seoAlerts">
                <SeoAlertsFeed />
            </AlertsErrorBoundary>
        </Stack>
    );
};
